var ViewState = Backbone.Model.extend({
    initialize: function (data, options) {
        this.session = options.session;
        this.session.bind('change:last_selected_bid', this.setCurrentBuffer, this);
        
        this.timeout = null;
    },
    updateSeenEid: function (buffer) {
        var seenEids = this.get('seenEids') || {};
        if (!seenEids[buffer.getCid()]) {
            seenEids[buffer.getCid()] = {};
        }
        seenEids[buffer.getCid()][buffer.bid()] = buffer.getLastSeen();
        this.set({'seenEids': seenEids});
    },
    setCurrentBuffer: function (session) {
        this.set({'selectedBuffer': session.get('last_selected_bid')});
    },
    scheduleSendState: function () {
        var self = this;
        this.timeout = setTimeout(function () {
            self.sendState();
        }, 2000);
    },
    sendState: function () {
        if (this.has('selectedBuffer') || this.has('seenEids')) {
            this.session.post("heartbeat", {
                selectedBuffer: this.get('selectedBuffer'),
                seenEids: JSON.stringify(this.get('seenEids'))
            });
            this.clear();
        }
        this.scheduleSendState();
    },
    
    startHeartbeat: function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.scheduleSendState();
    }
});

module.exports = ViewState;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/viewstate.js
// module id = rEXR
// module chunks = 1